<template>
  <section id="admin-manager-list">
    <b-card class="admin-page-mobile">
        <b-button
            class="btn-sm mb-1"
            :variant="isMobile ? 'outline-light': 'outline-primary'"
          @click="showModal"
        >
          <feather-icon
              icon="PlusIcon"
              size="22"
              class="align-text-top"
          /> افزودن
        </b-button>

        <v-data-table
            v-bind="{dark : isMobile }"
          :headers="headers"
          :items="desserts"
            :search="search"
          mobile-breakpoint="0"
            loading
            loading-text="Loading... Please wait"
        >
          <template v-slot:top>
            <v-text-field
                v-model="search"
                label="جستجو"
                class="mx-4"
                style=""
            ></v-text-field>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
                @click="onEditItem(item)"
            >
              mdi-circle-edit-outline
            </v-icon>
            <v-icon
                style="margin-right: 7px"
                @click="onDeleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn
              color="primary"
              @click="initialize"
            >
              Reset
            </v-btn>
          </template>
        </v-data-table>

        <!-- modal login-->
        <b-modal
          ref="modal-addManager"
          cancel-variant="outline-secondary"
          ok-title="افزودن"
          cancel-title="بستن"
          centered
          title="نماینده جدید"
        >
          <b-form>
            <b-form-group
              label="لیست کاربران:"
              label-for="vi-port"
            >
              <b-input-group class="input-group-merge">
                <model-list-select
                    v-model="selected"
                    :list="options"
                    option-value="_id"
                    :custom-text="optionDisplayText"
                    placeholder="کاربران"
                />
              </b-input-group>
            </b-form-group>
          </b-form>

          <template #modal-footer="">
            <b-button
              size="sm"
              variant="danger"
              @click="hideModal"
            >
              بستن
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="modalOk()"
            >
              ذخیره
            </b-button>
          </template>
        </b-modal>
    </b-card>
  </section>

</template>
<script>
import {
  BCard, BCardBody, BButton, BModal, BForm, BFormGroup, BFormSelect, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import router from '@/router'
import customerService from '@/services/customer.service'
import Customer from '@/models/customer'

import BreadcrumbMobile from '@/layouts/breadcrumb.vue'
import Vue from 'vue'
import { ModelListSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
  components: {
    ModelListSelect,
    BCard,
    BModal,
    BButton,
    BCardBody,
    BForm,
    BFormGroup,
    BFormSelect,
    BInputGroup,
    BInputGroupPrepend,
  },
  data() {
    return {
      search: '',
      customer: new Customer('', '', '', '', '', ''),
      desserts: [],
      selected: '',
      options: [],
      isMobile: Vue.prototype.$functions.isMobile(),
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'نام',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'نام خانوادگی', value: 'family' },
        { text: 'موبایل', value: 'mobile' },
        { text: 'نوع', value: 'type' },
        { text: 'تاریخ ایجاد', value: 'creationDate' },
        { text: 'عملیات', value: 'actions', sortable: false },
      ]
    },
  },
  async mounted() {
    this.initializeOption()
  },
  async created() {
    this.$vuetify.rtl = true
    this.initialize()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
      // eslint-disable-next-line no-underscore-dangle
    },
  },
  methods: {
    optionDisplayText(animation) {
      return `${animation.name} ${animation.family} - ${animation.mobile}`
    },
    initializeOption() {
      try {
        customerService.getAll({ type: 0 }).then(
          res => {
            if (res.status === 'success') {
              if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
                this.options = res.result.data
              } else {
                this.options = []
              }
            }
          },
        )
      } catch (err) {
        // console.log(err)
      }
    },
    initialize() {
      this.desserts = []
      customerService.getAll({ type: 2 }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                const temp = res.result.data[i]
                temp.creationDate = new Date(temp.creationTime * 1000).toLocaleDateString('fa-IR')
                this.desserts.push(temp)
              }
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    addClick() {
      router.push({ path: '/admin/manager/add' })
    },
    modalOk() {
      customerService.addManager({ _id: this.selected }).then(
        res => {
          if (res.status === 'success') {
            this.$refs['modal-addManager'].hide()
            this.initialize()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    onDeleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('آیا مطمئنید؟')) {
        customerService.removeManager({
          // eslint-disable-next-line no-underscore-dangle
          _id: this.desserts[index]._id,
        }).then(
          res => {
            if (res.status !== 'success') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'register error',
                  text: res.result,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
      } else {
        index = ''
      }
    },
    onEditItem(item) {
      const index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-underscore-dangle
      const id = this.desserts[index]._id
      router.push({ name: 'admin-manager-edit', params: { id } })
    },
    showModal() {
      this.initializeOption()
      this.$refs['modal-addManager'].show()
    },
    hideModal() {
      this.$refs['modal-addManager'].hide()
    },
  },
}
</script>
